import { all, call, put } from 'redux-saga/effects';

import { downloadSuccess, downloadFailure } from '@actions/vatReturn';
import { getFiledReturnFilesList } from '@api/vatReturn';
import { toastError } from '@store/notifications';

import { handleDownloadFiledReturn } from '../handleDownloadFiledReturn';

export const handleDownloadFiledReturnFiles = function* ({ payload }) {
  try {
    const response = yield call(getFiledReturnFilesList, payload.id);
    const filedReturns = response.results.filter(item => item.category === 'vat_return');

    if (filedReturns.length) {
      yield all(
        filedReturns.map(file =>
          call(handleDownloadFiledReturn, { payload: { id: file.id, filename: file.name } })
        )
      );
    } else {
      yield put(
        toastError({
          message: {
            id: 'global.notification.download-filed-return-no-files',
            defaultMessage: 'No matching files could be found',
          },
        })
      );
    }

    yield put(downloadSuccess());
  } catch (error) {
    const { nonFieldErrors } = error?.data || {};

    yield put([
      toastError({
        message: nonFieldErrors || {
          id: 'global.notification.download-filed-return-failed',
          defaultMessage: 'Your download could not be completed',
        },
      }),
      downloadFailure(),
    ]);
  }
};
